// extracted by mini-css-extract-plugin
module.exports = {"dashboard-card":"card_dashboard-card__uKZ4q","content":"card_content__24Nyv"};